module.exports = __webpack_public_path__ + "portal-static/img/home_ico_classview.59fc1234.png";